export default __webpack_public_path__ + "static/media/frappuccino-breverage.aa3672dd.webp";